/**
 * @file The Column Repeat component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../../base/columns/column-base/column-base';
import { ColumnProvider } from '../../base/column-provider';
import { LocalisationService } from '../../core/localisation.service';
import { RepeatAdapter } from '../helpers/repeat-adapter';
import { TranslateService } from '@ngx-translate/core';
import { DomainService } from '../../domain.service';
import { ComponentRegistry } from '../../core/component-registry';
var ColumnRepeatComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnRepeatComponent, _super);
    /**
     * Constructs a ColumnRepeatComponent.
     * @param translateService Is needed to get a summary of the repeat.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnRepeatComponent(provider, changeDetector, translateService, localisationService, domainService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.repeat = new RepeatAdapter(function () {
            var repeat = provider.value;
            if (repeat && !repeat.Owner) {
                var wasModified = repeat.entityAspect.entityState.isModified();
                repeat.Owner = provider.entity;
                if (!wasModified) {
                    repeat.entityAspect.setUnchanged();
                }
            }
            return repeat;
        }, translateService, localisationService, domainService);
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnRepeatComponent.register = function () {
        ComponentRegistry.register('column', 'repeat', ColumnRepeatComponent);
    };
    Object.defineProperty(ColumnRepeatComponent.prototype, "summary", {
        /**
         * Gets the summary of the current repeat.
         */
        get: function () {
            return this.repeat.summary();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Optimised change detection is not suported for this component,
     * so we override with an empty method.
     * @protected
     */
    ColumnRepeatComponent.prototype.startOptimisedChangeDetection = function () {
        // Does nothing.
    };
    return ColumnRepeatComponent;
}(ColumnBase));
export { ColumnRepeatComponent };
